<template>
    <svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.9667 7.03336L8.96667 7.03335M16.5333 9.15518H7.17555V3.46667H3.46667V9.38047C3.48569 10.6008 4.33398 13.154 7.57497 13.6046V16.5333H12.1968V13.6046C13.6423 13.3793 16.5333 12.174 16.5333 9.15518Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M3 2.5L17.5 17" stroke="white" stroke-width="3" />
        <path d="M3 2.5L17.5 17" stroke="black" />
    </svg>
</template>
